import React, { useMemo, useEffect } from 'react';
import { Stepper } from '@shared/components/Stepper';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';
import { useFormCompletionTracker } from '@shared/hooks/useFormCompletionTracker';
import { useNavigate } from 'react-router-dom';

import { BasicInfo } from './BasicInfo';
import { RateStructure } from './RateStructure';
import { RateConfiguration } from './RateConfiguration/RateConfiguration';
import { ReviewPublish } from './ReviewPublish';
import { PageHeader } from '@shared/components/PageHeader';
import { ArrowLeft } from 'lucide-react';

export const CreateRate: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const storageKey = `rate-create-progress-${remoteUtilityId}`;
  const { startTracking, logTimeUntilStep, stopTracking } = useFormCompletionTracker("Rate");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const handlePopState = () => {
  //     if (!window.location.hash) {
  //       // when hash is cleared, redirect to parent route
  //       navigate("/onboarding/plan-rates", { replace: true });
  //     }
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, [navigate]);

  useEffect(() => {
    startTracking()
  }, [startTracking])

  // Clear data when navigating away from this component (unmount)
  useEffect(() => {
    return () => {
      localStorage.removeItem(storageKey);
    };
  }, [storageKey]);

  // Memoize the steps array to prevent infinite re-renders
  const steps = useMemo(
    () => [
      {
        title: "Basic Info",
        slug: "basic-info", // Add slug for routing
        component: (
          <BasicInfo
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
        
      },
      {
        title: "Rate Structure",
        slug: "rate-structure", // Add slug for routing
        component: (
          <RateStructure
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
        
      },
      {
        title: "Rate Configuration",
        slug: "rate-configuration", // Add slug for routing
        component: (
          <RateConfiguration
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
          />
        ),
        optional: false,
        
      },
      {
        title: "Review & Publish",
        slug: "review-publish", // Add slug for routing
        component: (
          <ReviewPublish
            remoteUtilityId={Number(remoteUtilityId)}
            storageKey={storageKey}
            logTimeUntilStep={logTimeUntilStep}
            stopTracking={stopTracking}
          />
        ),
        optional: false,
        
      },
    ],
    [remoteUtilityId, storageKey, logTimeUntilStep, stopTracking]
  ); // Only recreate when dependencies change

  return (
    <div>
      <PageHeader 
        title='Create Rate' 
        subtitle='Step through the wizard to define structure, rates, assignment.'
        icon={ArrowLeft}
        onIconClick={()=>navigate('/plan-tarrif/plan-tarrif-landing?tab=tariff')}
      />

      <Stepper
        steps={steps}
        onStepChange={() => {}}
        onStepSave={async (stepIndex, stepData, isDirty) => {
          // Storage is handled at component level using step helpers
        }}
        enableApiSave={false}
        saveOnStepChange={false}
        trackDirtyState={false}
        autoSave={true}
        persistProgress={true}
        allowSkip={false} // Set to false since all steps are required
        storageKey={storageKey}
        enableRouting={true} // Enable hash-based routing (no 404s on refresh)
        onValidation={undefined} // basePath is not needed for hash-based routing
        onComplete={() => {}}
        showDraftResume={true}
        className='mt-4'
      />
    </div>
  );
};
